import { useQuery } from '@tanstack/react-query';
import {
  ListShadowSystemsResponseSchema,
  type ListShadowSystemsResponse
} from '@bliks-io/contracts';
import { apiClient } from '../client';
import { entitySuggestionKeys } from '../query-keys';

export function useShadowSystems() {
  return useQuery({
    queryKey: entitySuggestionKeys.shadowSystems(),
    queryFn: async () => {
      const { data } = await apiClient.get<ListShadowSystemsResponse>(
        '/api/v2/entity-suggestion/shadow-systems'
      );
      return ListShadowSystemsResponseSchema.parse(data);
    }
  });
}
